import React, { useEffect, useState } from 'react';
import './gyogik.css';
import { useParams,Link } from "react-router-dom"



function Tell_info() {
  const { variable3, variable4 } = useParams(); // 두 변수를 가져옵니다.
  const [data, setData] = useState([]);
  const [gyogik, setgyogik] = useState([]);
  useEffect(() => {
    const url3 = `/backend/gyogik`;
    fetch(url3)
    .then(response => response.json())
    .then(data => {
      // 서버로부터 받은 데이터 처리
      console.log(data);
      setgyogik(data);
      console.log(Array.isArray(data));
    })
  }, []);
  const filteredItem = gyogik.find(item => item.CNWK_YRCO === variable3);

  return (
    <div className="container">
      <div className="page">
         <div className="AppG App-headerG gnb_bsG">
         <header style={{width: "100%"}}>
          <div className="gnb_1">
          <button onClick={() => window.history.back()} class="arrow-button">
  <span class="arrow-icon"></span>
</button>
                <span className="title">{variable4}</span>
                <div className="gnb_1_1">
                    <Link className="gnb_qrG" to="/qr">
                        <div className="gnb_qrG"></div>
                    </Link>
                    <a className="gnb_notiG" href="/"></a>
                </div>
          </div>
        </header>
          <div className="body">
            
          <div>
    {filteredItem && (
      <div className="list_info_s">
        <div className="box">
          <div className="txt">
            <span>{variable4}</span>
            <a>TEL : {filteredItem.HT_TEL}</a>
            <a>{filteredItem.WORK}</a>
          </div>
        </div>
      </div>
    )}
  </div>

          </div>
	      </div>
	    </div>
	  </div>
  );
}

export default Tell_info;

